import { Pipe, PipeTransform } from '@angular/core';
import { SigntrustUtilsService } from '@services/index.service';
import { AsyncSubject, Observable, Subject } from 'rxjs';


@Pipe({
    name: 'fileToBase64',
    standalone: false
})
export class FileToBase64Pipe implements PipeTransform {
  constructor(private _utilsSigntrust: SigntrustUtilsService) {}

  public transform(value: File): Observable<string> {
    return this._utilsSigntrust.fileToBase64(value);
  }
}
